/* =====================================================================
   mw-size-note.js — "Small" is not a size.

   Shopify's option buttons print the option VALUE and nothing else, so
   a customer choosing between Small and Medium is choosing between two
   words. This puts the inches directly under the buttons, which is
   where the choice is actually made.

   It is shared, because two different kinds of product page need it:
   the personalisation panel and the artwork form.

   HOW IT FINDS THE RIGHT GROUP
   By the option VALUES, not by an option named "Size". The option can
   be renamed in the admin at any time; the values are the ones the
   theme was built against. Matching on the name would fail silently —
   the worst way for something to fail, because the page still looks
   finished.
===================================================================== */
window.MWSizeNote = (function () {
  'use strict';

  function mount(sizes) {
    if (!sizes || !sizes.length) return null;

    var byValue = {};
    var values = sizes.map(function (z) { byValue[z.value] = z.dim; return z.value; });

    var groups = document.querySelectorAll('.variant-option');
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      var fields = group.querySelectorAll('input, option');
      var mine = false;
      for (var f = 0; f < fields.length; f++) {
        if (values.indexOf((fields[f].value || '').trim()) !== -1) { mine = true; break; }
      }
      if (!mine) continue;

      var note = group.querySelector('.mw-size-under');
      if (!note) {
        note = document.createElement('p');
        note.className = 'mw-size-under';
        group.appendChild(note);
      }

      var paint = function () {
        var chosen = group.querySelector('input:checked');
        var value = chosen ? chosen.value
          : (group.querySelector('select') || {}).value || '';
        var dim = byValue[(value || '').trim()];
        note.textContent = dim || '';
        note.hidden = !dim;
      };

      group.addEventListener('change', paint);
      paint();
      return { group: group, note: note, paint: paint };
    }
    return null;
  }

  /* THE NOTE HAS TO SURVIVE THE PICKER BEING REBUILT.

     David, 2026-09-29: "clicking through the sizes on the state board
     got rid of the sizing". Horizon re-renders the whole variant
     section when a variant changes — it throws the fieldset away and
     draws a new one — and the note went into the bin with it. A retry
     that gives up after three seconds could not save it, because the
     thing that destroys it happens minutes later, on a click.

     So it is watched instead of timed. `mount` is idempotent (it reuses
     an existing note rather than adding a second), so re-running it on
     every DOM change is cheap and cannot loop: the re-run finds the note
     already in place and changes nothing, which produces no mutation. */
  function mountWhenReady(sizes) {
    if (!sizes || !sizes.length) return null;

    var pending = false;
    var remount = function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; mount(sizes); });
    };

    var got = mount(sizes);
    new MutationObserver(remount).observe(document.body, { childList: true, subtree: true });
    return got;
  }

  return { mount: mount, mountWhenReady: mountWhenReady };
})();
